export class Retailer {
  id: number;
  name: string;
  selected: boolean;
}
